// extracted by mini-css-extract-plugin
module.exports = {"postList":"postList-module--postList--d2P4A","postListDivider":"postList-module--postListDivider--1jKeW"};